if (!customElements.get('variant-handler')) {
  class VariantHandler extends HTMLElement {
    constructor() {
      super();
      this.variantPicker = this.closest('.product').querySelector('variant-picker');
      this.warningElement = this.querySelector('.product-message');
      this.collectionWarning = this.dataset.collectionWarning || '';
      this.productWarning = this.dataset.productWarning || '';
      this.variantWarning = this.dataset.variantWarning || '';
      
      if (this.variantPicker) {
        this.variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    /**
     * Handles variant change events
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.updateWarningMessage(evt.detail.variant);
        this.updateSizeChart(evt.detail.variant);
        // Add more variant-specific updates here in the future
      }
    }

    /**
     * Updates the warning message based on variant
     * @param {object} variant - The selected variant
     */
    updateWarningMessage(variant) {
      let message = '';
      let showWarning = false;

      // Debug logging
      console.log('Variant title:', variant.title);
      console.log('Collection warning:', this.collectionWarning);
      console.log('Product warning:', this.productWarning);
      console.log('Variant warning:', this.variantWarning);

      // Check if variant title contains "4 x 4 Set"
      if (variant.title && variant.title.includes('4 x 4 Set')) {
        console.log('4x4 variant detected');
        // Hardcoded message for 4x4 variants
        message = 'Heavy or bulk item! You will need adequate manpower ( 1 persons ) to unload when the goods arrive. ';
        showWarning = true;
        console.log('Using hardcoded variant warning:', message);
      } else {
        console.log('Not a 4x4 variant');
        // Use product warning if available, otherwise collection warning
        if (this.productWarning) {
          message = this.productWarning;
          showWarning = true;
        } else if (this.collectionWarning) {
          message = this.collectionWarning;
          showWarning = true;
        }
      }

      // Update the warning display
      if (showWarning && this.warningElement) {
        const messageElement = this.warningElement.querySelector('.rte');
        if (messageElement) {
          messageElement.innerHTML = message;
        }
        this.warningElement.style.display = 'block';
      } else if (this.warningElement) {
        this.warningElement.style.display = 'none';
      }
    }

    /**
     * Updates size chart based on variant (for future implementation)
     * @param {object} variant - The selected variant
     */
    updateSizeChart(variant) {
      // This will be implemented when you add size charts
      // For now, it's a placeholder for future functionality
      console.log('Size chart update for variant:', variant.title);
    }
  }

  customElements.define('variant-handler', VariantHandler);
}
